module.exports = __webpack_public_path__ + "static/img/blackLogo.dbdc569.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header/blackLogo.png
// module id = fJ2S
// module chunks = 1